import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './menuIcon.css'
import PropTypes from 'prop-types';

class PopupModal extends React.Component {
  render() {
          return (
              <div data-test = 'popupModalComponent'>
                  <Modal isOpen={true}>

                      <ModalHeader
                          toggle={this.props.closePopup}
                          style={window.location.pathname.includes("/close_loop_validation")===true?{color:"#464646"}:{ color:"#524fa1" }}
                      >
                      {this.props.heading === undefined ? "Status" : "Confirmation"}
                      </ModalHeader>
                      <ModalBody>
                      <div className="card">
                        <div className="card-body">
                        <p>
                            {this.props.text}
                        </p>
                        </div>
                      </div>

                      </ModalBody>
                      <ModalFooter>
                        <Button color="" className="btn btn-primary" onClick={this.props.closePopup}>Ok</Button>
                      </ModalFooter>
                    </Modal>

              </div>
            )
}
}
PopupModal.propTypes={
heading:PropTypes.array,
closePopup:PropTypes.func,
text:PropTypes.string,

}
PopupModal.defaultProps= {
heading:[],
closePopup:[],
text:[],
}
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default PopupModal;
